<template>
  <div class="r-table-row-wrapper">
    <div class="r-table-row">
      <div class="r-table-col">{{ formatDate(reservation.bookDate) }} {{formatTime2(reservation.bookDate)}}</div>
      <div class="r-table-col">{{ reservation.customer.seats }}</div>
      <div class="r-table-col">{{ reservation.customer.name }} {{ reservation.customer.lastname }}</div>
      <div class="r-table-col">{{ reservation.customer.email }}</div>
      <div class="r-table-col">{{ reservation.customer.phone }}</div>
      <div class="r-table-col">{{ status_text }}</div>
      <div class="r-table-col"><i @click="toggle" class="fas fa-file-alt"></i></div>
    </div>
    <div v-if="toggleDetail" class="guest-details">
      <div class="guest-details-row">
        <div class="guest-details-column">Reservation Date</div>
        <div class="guest-details-column">{{ formatDate(reservation.bookDate) }} {{formatTime2(reservation.bookDate)}}</div>
      </div>
      <div class="guest-details-row">
        <div class="guest-details-column">Party Size</div>
        <div class="guest-details-column">{{ reservation.customer.seats }}</div>
      </div>
      <div class="guest-details-row">
        <div class="guest-details-column">Customer Name</div>
        <div class="guest-details-column">{{ reservation.customer.name }} {{ reservation.customer.lastname }}</div>
      </div>
      <div class="guest-details-row">
        <div class="guest-details-column">Customer Email</div>
        <div class="guest-details-column">{{ reservation.customer.email }}</div>
      </div>
      <div class="guest-details-row">
        <div class="guest-details-column">Customer Phone</div>
        <div class="guest-details-column">{{ reservation.customer.phone }}</div>
      </div>
      <div class="guest-details-row">
        <div class="guest-details-column">Reservation Status</div>
        <div class="guest-details-column">{{ status_text }}</div>
      </div>
      <div class="guest-details-row" v-if="!reservation.valid && reservation.reason">
        <div class="guest-details-column">Reason</div>
        <div class="guest-details-column">{{ reservation.reason }}</div>
      </div>
      <div class="guest-details-row">
        <div class="guest-details-column">Occasion</div>
        <div class="guest-details-column">{{ reservation.occasion }}</div>
      </div>
      <div class="guest-details-row">
        <div class="guest-details-column">Special Request</div>
        <div class="guest-details-column">{{ reservation.customer.note }}</div>
      </div>

      <cancel-reservation-popup :is-sidebar-active="confirmDialog" :setup="true" :end="statusConfirm"  @closeSidebar="confirmDialog = false" />
      <cancel-reservation-popup :is-sidebar-active="deleteDialog" :setup="false" :end="statusConfirm"  @closeSidebar="deleteDialog = false" />

      <div class="flex flex-wrap py-4">
        <div v-if="!reservation.valid && !reservation.reason" class="r-save-button mr-2" @click="confirmDialog = true">Confirm</div>
        <div v-if="!reservation.reason" class="r-cancel-button" @click="deleteDialog = true">Decline</div>
      </div>


    </div>
  </div>
</template>

<script>
import moment from 'moment'
import CancelReservationPopup from './CancelReservationPopup'
import axios from '../../axios'
export default {
  props: {
    reservation: {
      type: Object
    },
    updated: {
      type: Function
    }
  },
  components: {
    moment,
    CancelReservationPopup
  },
  data () {
    return {
      toggleDetail: false,
      confirmDialog: false,
      deleteDialog: false,
      reason: ''
    }
  },
  computed: {
    status_text () {
      if (!this.reservation.valid && this.reservation.reason) {
        return 'Cancelled'
      } else {
        return this.reservation.valid ? 'Confirmed' : 'Waiting for confirmation'
      }
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }
      }
      return obj
    },
    token: {
      get () {
        return this.$store.state.api.reservationToken
      },
      set (val) {
        this.$store.commit('api/SET_RESERVATION_TOKEN', val)
      }
    }
  },
  name: 'ReservationListItem',
  methods: {
    statusConfirm (status, reason) {
      if (!status) {
        this.reason = reason
        this.cancel()
      } else {
        this.confirm()
      }
    },
    confirm () {

      const urlSuffix = this.selectedRestaurant.user_property.Address
      const payload = {
        valid: true,
        restaurant: {
          name: this.selectedRestaurant.user_property['Restaurant-Name'],
          menu_url: `https://turkishrestaurant.com/restaurants/${this.selectedRestaurant.user_property['Alias']}`,
          directions: 'https://www.google.com/maps/search/?api=1&query='.concat(urlSuffix),
          address: this.selectedRestaurant.user_property['Address'],
          phone: this.selectedRestaurant.phone
        }
      }
      this.handle(payload)
    },
    cancel () {
      const urlSuffix = this.selectedRestaurant.user_property.Address
      const payload = {
        valid: false,
        reason: this.reason,
        restaurant: {
          name: this.selectedRestaurant.user_property['Restaurant-Name'],
          menu_url: `https://turkishrestaurant.com/restaurants/${this.selectedRestaurant.user_property['Alias']}`,
          directions: 'https://www.google.com/maps/search/?api=1&query='.concat(urlSuffix),
          address: this.selectedRestaurant.user_property['Address'],
          phone: this.selectedRestaurant.phone
        }
      }
      this.handle(payload)
    },

    handle (payload) {
      axios
        .put(`https://reservations.authorizelocal.com/api/book/${this.reservation._id}`, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
          }
        })
        .then(response => {
          if (response.data.status) {
            this.updated()
            this.$vs.notify({
              title: 'Success',
              text: 'Updated successfully',
              iconPack: 'feather',
              icon: 'icon-alert-check',
              color: 'success'
            })
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Could not save reservation',
            text: 'Reservation error',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    toggle () {
      this.toggleDetail = !this.toggleDetail
    },
    formatDate (date) {
      const result = moment.utc(date).format('MMM DD, YYYY')
      return result
    },
    formatTime (date) {
      const result = moment.utc(date).add(2, 'hours').format('hh:00 A')
      return result
    },
    formatTime2 (date) {
      const result = moment.utc(date).format('hh:mm A')
      return result
    }
  }
}
</script>

<style scoped>

</style>
